import { useEffect } from 'react';

const useTableDragScroll = (dependencies = []) => {
  useEffect(() => {
    const scrollableElement = document.querySelector('.table-respoinsive .ant-table-content');
    
    if (!scrollableElement) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      if (e.target.closest('a, button, input')) return;
      
      isDown = true;
      startX = e.pageX - scrollableElement.offsetLeft;
      scrollLeft = scrollableElement.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
    };

    const handleMouseUp = () => {
      isDown = false;
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - scrollableElement.offsetLeft;
      const walk = (x - startX) * 2;
      scrollableElement.scrollLeft = scrollLeft - walk;
    };

    scrollableElement.addEventListener('mousedown', handleMouseDown);
    scrollableElement.addEventListener('mouseleave', handleMouseLeave);
    scrollableElement.addEventListener('mouseup', handleMouseUp);
    scrollableElement.addEventListener('mousemove', handleMouseMove);

    return () => {
      scrollableElement.removeEventListener('mousedown', handleMouseDown);
      scrollableElement.removeEventListener('mouseleave', handleMouseLeave);
      scrollableElement.removeEventListener('mouseup', handleMouseUp);
      scrollableElement.removeEventListener('mousemove', handleMouseMove);
    };
  }, dependencies);
};

export default useTableDragScroll;


